<template>
  <p v-if="rows.length">
    <template v-if="loading">
      <span>
        <Skeleton :count="1" />
        <Skeleton :count="1" />
        <Skeleton :count="1" />
      </span>
    </template>
    <template v-if="rows.length">
      <span class="text-muted">
        <b>Quick Reply</b>
      </span>
      <span v-for="(row,index) in rows" :key="index">
        <a @click="detailData(row.id)" :class="'badge badge-primary  ' ">{{row.title}}</a>&nbsp;
      </span>
    </template>
    <a
      v-show="false"
      ref="formPreviewQuickReply"
      class="btn add-btn"
      @click="showBroadcast(false)"
      href="#"
      data-toggle="modal"
      data-target="#add_form"
    >
      <i class="fa fa-whatsapp"></i> Edit
    </a>
    <quick-reply-preview :buttonsRows="buttonsRows" :linkRows="linkRows" />
  </p>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import QuickReplyPreview from "./quickReplyPreview.vue";

export default {
  components: {
    Skeleton,
    QuickReplyPreview
  },
  data() {
    return {
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsRows: [],
      linkRows: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          title: "",
          message: "",
          is_publish: "publish",
        },
        page: 0,
        perPage: 20 // perPage
      }
    };
  },
  watch: {},
  created() {
    this.loadItems();
    this.loadReplyButtons();
    this.loadReplyLink();
  },
  methods: {
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch(error => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("automation/setIsShowForm", false);
        this.selectedLicense = [];

        let formData = {
          header: {
            id: "",
            license_id: "",
            message: "",
            footer_message: "",
            footer_message_status: false
          },
          detail_button: [
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            }
          ],
          detail_button_away: [
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            },
            {
              auto_reply_button_id: ""
            }
          ]
        };
        this.$store.dispatch("automation/actFormParamQRSt", formData);
      }
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        if (isShowModal == true) {
          that.$store.dispatch("automation/setIsShowForm", true);
        }
      }, 1000);
    },
    async detailData(id) {
      //set false dulu
      this.loading = await true;
      this.$store.dispatch("automation/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id
      };
      let formData = await {};
      await this.$store
        .dispatch("automation/detailQuickReplyForEdit", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          data.header.is_custom_url = false;
          data.header.is_enable_attach_file = false;
          if (data.header.image_url != "") {
            data.header.is_enable_attach_file = true;
          }
          formData = data;
          this.loading = false;
        });
      // console.log("formData::", formData);
      // formData.id = id;
      await this.$store.dispatch("automation/actFormParamQRSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formPreviewQuickReply;
      elem.click();
    },
    async loadItems() {
      this.loading = await true;

      await this.$store
        .dispatch("automation/listQuickReply", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  name: "quickreply-list"
};
</script>


// WEBPACK FOOTER //
// src/views/omni/components/quickReply.vue